<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner" :style="{alignItems: 'flex-start'}">
      <div class="edit-popup edit-popup--invoice-partially-paid">
        <div class="edit-popup__header edit-popup__header-invoice-partially-paid">
          <div class="edit-popup__title">
            <span>Status: Partially Paid</span>
          </div>
          <div class="edit-popup__close" @click="closeModal">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>

      <div class="partially-paid-block">
        <div class="partially-paid-top">
          <div class="partially-paid-top_services"><span>Description of services</span></div>
          <div class="partially-paid-top_qty"><span>Qty</span></div>
          <div class="partially-paid-top_price"><span>Price</span></div>
          <div class="partially-paid-top_total"><span>To be paid</span></div>
          <div class="partially-paid-top_paid"><span>Amount Paid</span></div>
        </div>
        <div class="partially-paid-item" v-for="(service, index) in invoice.services" :key="service.id">
          <div class="partially-paid-item_services">
            <template v-if="service.type === 'CUSTOM' || service.type === 'ADDITIONAL_OPTION'">
              <svg
                  width="20px"
                  height="20px"
                  class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
              >
              <span>Custom</span>
            </template>
            <template v-if="service.type === 'OTHER_EXPENSES' || service.type === 'ADDITIONAL_SERVICE'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
              >
              <span>Other</span>
            </template>
            <template v-if="service.type === 'AIRPORT_VIP_SERVICE'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
              >
              <span>Airport</span>
            </template>
            <template v-if="service.type === 'TRANSFER'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
              >
              <span>Transfer</span>
            </template>
            <template v-if="service.type === 'FLIGHT'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
              >
              <span>Flight</span>
            </template>
            <template v-if="service.type === 'MAINLAND'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
              >
              <span>Day Trips</span>
            </template>
            <template v-if="service.type === 'ISLAND' || service.type === 'ISLAND_TRANSFER' || service.type === 'ISLAND_DAY_TRIP'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
              >
              <span>Island</span>
            </template>
            <template v-if="service.type === 'SAFARI' || service.type === 'SAFARI_ACTIVITY'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
              >
              <span>Safari</span>
            </template>
            <template v-if="service.type === 'CLIMBING' || service.type === 'CLIMBING_RENTAL' || service.type === 'CLIMBING_EXTRA'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
              >
              <span>Climbing</span>
            </template>
            <template v-if="service.type === 'EXTRA_ACCOMMODATION'">
              <svg
                   width="20px"
                   height="20px"
                   class="icon icon-categories">
                <use
                    xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
              >
              <span>Extra Accommodation</span>
            </template>
          </div>
          <div class="partially-paid-item_desc">
            <span>{{service.name}}</span>
          </div>
          <div class="partially-paid-item_qty">
            <span>{{service.quantity}}</span>
          </div>
          <div class="partially-paid-item_price">
            <span>{{getCurrencySign(invoice.currencyType)}} {{numberWithCommas(service.price)}}</span>
          </div>
          <div class="partially-paid-item_total">
            <span>{{getCurrencySign(invoice.currencyType)}} {{numberWithCommas(service.amountPayable)}}</span>
          </div>
          <div class="partially-paid-item_paid">
            <div
                :class="[
                      'form-control-wrap form-control-wrap--days',
                      {'is-error': false},
                    ]">
<!--              <input-->
<!--                  type="number"-->
<!--                  :placeholder="invoice.services[index].amountPaid"-->
<!--                  v-model="invoice.services[index].amountPaid"-->
<!--                  @input="-->
<!--                    invoice.services[index].amountPaid = $event.target.value.replace(/[^0-9]/g, '')-->
<!--                    invoice.services[index].amountPaid = +invoice.services[index].amountPaid-->
<!--                  "-->
<!--                  class="form-control" />-->
              <input
                  type="number"
                  :placeholder="invoice.services[index].amountPaid"
                  @input="currentInvoiceServiceAmountPaid($event.target.value, index)"
                  class="form-control" />
                    <div class="form-control-label-descr">
                <span>{{getCurrencySign(invoice.currencyType)}}</span>
              </div>
            </div>
          </div>
        </div>


        <div class="partially-paid-options">
          <div class="partially-paid-options_data">
            <div class="data_select-payment">
              <span class="title">Payment Method</span>
              <payment-method-select
                  v-model="templateInvoicePartiallyPaid.status.partiallyPaidData.paymentMethod"
                  :bank-id="invoice.bankId"
                  :disabled="!hasClientContract && !isAdmin"
                  :is-admin="isAdmin"
              />
            </div>
            <div class="data_datePayment">
              <span class="title">Date of Payment</span>
              <div class="form-control-wrap">
                <input
                    type="text"
                    placeholder="Date"
                    v-model="templateInvoicePartiallyPaid.status.partiallyPaidData.dateOfPayment"
                    @blur="convectorFormat($event.target.value)"
                    class="form-control js-datepicker-single" />
                <div class="form-control-icon">
                  <svg
                      width="1em"
                      height="1em"
                      class="icon icon-calendar">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="partially-paid-options_btn" @click="upInvoiceStatusPartiallyPaid">
            <div class="btn btn--green">
              <span>Save</span>
            </div>
          </div>
        </div>
      </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vuex from "vuex";
import Lightpick from "lightpick";
import {actionTypes as actionTypesInvoice} from "@/store/modules/invoices";
import {getCurrencySign} from '@/common/helpers/currency'
import PaymentMethodSelect from '@/components/invoices/PaymentMethodSelect.vue'

export default {
  name: 'AtModalInvoiceStatusPartiallyPaid',
  components: {PaymentMethodSelect},
  props: {
    invoice: {
      type: Object,
      require: true
    },
    hasClientContract: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      templateInvoicePartiallyPaid: {
        status: {
          type: "",
          // paidData: {
          //   amountPaid: 0,
          //   dateOfPayment: "",
          //   paymentMethod: ""
          // },
          partiallyPaidData: {
            dateOfPayment: "",
            paymentMethod: "",
            services: [
              // {
              //   id: 0,
              //   name: "string",
              //   quantity: 0,
              //   price: 0,
              //   startDate: "2022-07-28",
              //   endDate: "2022-07-28",
              //   amountPaid: 0,
              //   amount: 0,
              //   type: "TRANSFER"
              // }
            ]
          }
        },
        userId: 0
      }
    }
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      updateInvoiceStatus: actionTypesInvoice.updateInvoiceStatus
    }),
    currentInvoiceServiceAmountPaid(value, index){
      // console.log(value)
      this.invoice.services[index].amountPaid = value
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    convectorFormat(date) {
      this.templateInvoicePartiallyPaid.status.partiallyPaidData.dateOfPayment = date
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD.MM.yyyy',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            },
          })
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        })
      }, 1000)
    },
    closeModal() {
      this.$emit('closeModalInvoiceStatusPartiallyPaidOptions', false)
      this.templateInvoicePartiallyPaid.status.type = ''
      this.templateInvoicePartiallyPaid.status.partiallyPaidData.amountPaid = 0
      this.templateInvoicePartiallyPaid.status.partiallyPaidData.dateOfPayment = ''
      this.templateInvoicePartiallyPaid.status.partiallyPaidData.paymentMethod = ''
      this.templateInvoicePartiallyPaid.userId = null
    },
    upInvoiceStatusPartiallyPaid() {
      this.invoice.services.map(s => {
        this.templateInvoicePartiallyPaid.status.partiallyPaidData.services.push(s)
      })
      const payload = {
        param: this.templateInvoicePartiallyPaid,
        invoiceId: this.invoice.id
      }

      this.updateInvoiceStatus(payload).then(() => this.closeModal())

      // console.log(this.templateInvoicePartiallyPaid)
    }
  },
  mounted() {
    this.updateDatePickers()

    this.templateInvoicePartiallyPaid.status.type = this.invoice.status
    this.templateInvoicePartiallyPaid.status.partiallyPaidData.amountPaid = this.invoice.remainAmount
    this.templateInvoicePartiallyPaid.status.partiallyPaidData.dateOfPayment = this.invoice.dateOfPayment
    this.templateInvoicePartiallyPaid.status.partiallyPaidData.paymentMethod = this.invoice.paymentMethod
    this.templateInvoicePartiallyPaid.userId = this.invoice.userId
  }
}
</script>
<style lang="scss" scoped>
.edit-popup {
  padding: 20px 35px 35px 35px;
}
.edit-popup--invoice-partially-paid {
  width: 772px;
  .partially-paid-block {
    .partially-paid-top {
      display: grid;
      grid-template-columns: 300px 27px 94px 100px 125px;
      grid-column-gap: 10px;

      padding-top: 20px;
      padding-bottom: 18px;
      span {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;

        color: #1A1A1A;
      }
    }
    .partially-paid-item {
      display: grid;
      grid-template-columns: 102px 189px 25px 95px 100px 125px;
      grid-column-gap: 10px;

      align-items: center;

      padding-bottom: 10px;

      .partially-paid-item_services {
        display: flex;
        align-items: center;

        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        svg {
          width: 20px;
          height: 20px;
        }
        span {
          width: 75px;

          display: block;

          font-weight: 500;
          font-size: 14px;
          line-height: 17px;

          color: #1A1A1A;

          padding-left: 7px;
        }
      }
      .partially-paid-item_desc {
        text-overflow: ellipsis;
        overflow: hidden;

        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #000000;
        }
      }
      .partially-paid-item_qty {
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #000000;
        }
      }
      .partially-paid-item_price {
        background: #F1F1F1;
        border-radius: 3px;
        padding: 9px;
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #000000;
        }
      }
      .partially-paid-item_total {
        background: #F1F1F1;
        border-radius: 3px;
        padding: 9px;
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #000000;
        }
      }


    }

    .partially-paid-options {
      padding-top: 47px;

      display: flex;
      align-items: flex-end;

      justify-content: space-between;

      .partially-paid-options_data {
        display: flex;
        align-items: center;

        .title {
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;

          color: #1A1A1A;
          display: block;
          padding-bottom: 7px;
        }


        .data_select-payment {
          width: 333px;

          margin-right: 20px;


        }

        .data_datePayment {
          width: 130px;
        }
      }
    }
  }
}
</style>
